/** @format */

import React from 'react';
import {
  Grid,
  Accordion,
  AccordionSummary,
  ButtonGroup,
  Button,
} from '@mui/material';
import { useCurrencyUnit } from 'hooks';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Icons, PriceLabel } from 'components';
import { useStyles } from './style';


const BlockAccount = (props) => {
  const classes = useStyles();
  const { data } = props;
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
    const currencyText = useCurrencyUnit(false);
  

  return (
    <>
      {data.length > 0 &&
        data.map((item, index) => (
          <Grid item key={`index-${index}`} lg={12}>
            <Accordion
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
            >
              <AccordionSummary
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>حساب مسدودی {item.name}</Typography>
                <Typography className={classes.secondaryHeading}>
                  موجودی:&nbsp;
                  <PriceLabel amount={item.inventory} currency={currencyText} />
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ButtonGroup color="primary" aria-label="outlined primary button group">
                  <Button>گزارش تراکنش ها</Button>
                </ButtonGroup>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
    </>
  );
};

export default BlockAccount;
